import React from "react";
import { Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import WhiteButton from "../../../../Common/WhiteButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

interface RadioOption {
  value: any;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface ButtonInputProps {
  value: any[];
  onChange: (values: any[]) => void;
  options: RadioOption[];
  isDisabled?: boolean;
  isSummary?: boolean;
  radioName?: string;
  isMultiple?: boolean;
}

export default function ButtonInput({
  value,
  onChange,
  options,
  isDisabled = false,
  isSummary = false,
  radioName = "radio",
  isMultiple = false,
}: ButtonInputProps) {
  return (
    <div
      className={`d-flex gap-2 flex-wrap ${
        isSummary ? "justify-content-end" : ""
      }`}
    >
      {options.map((opt) => (
        <Button
          variant=""
          className={`position-relative bg-white px-5 py-2 border border-2 ${
            value.includes(opt.value) ? "border-blue" : ""
          }`}
          key={opt.value}
          disabled={isDisabled || (opt.disabled as any)}
          onClick={() => {
            if (isMultiple) {
              if (value.includes(opt.value)) {
                onChange(value.filter((v) => v !== opt.value));
              } else {
                onChange([...value, opt.value]);
              }
            } else {
              if (value.includes(opt.value)) {
                onChange([]);
              } else {
                onChange([opt.value]);
              }
            }
          }}
        >
          {value.includes(opt.value) ? (
            <FontAwesomeIcon
              icon={faCheck}
              className="position-absolute top-0 end-0 text-white bg-colored p-1"
              style={{ borderBottomLeftRadius: 8 }}
            />
          ) : null}
          {opt.label}
        </Button>
      ))}
    </div>
  );
}
